<template>
  <md-dialog
    id="modUploadComponents"
    ref="editOsModal"
    md-title
    :md-esc-to-close="false"
    :md-click-outside-to-close="false"
    class="edit-os-modal"
  >
    <md-dialog-title>
      <span>Manutenção de OS</span>
      <button
        id="mod_btnClose"
        class="close-button btn-transparent"
        @click="closeMaintenanceModal()"
      >
        <md-icon>clear</md-icon>
      </button>
    </md-dialog-title>

    <md-dialog-content>
      <p>
        Pesquise abaixo
        <template v-if="!toggle.covax">a OS LIS</template>
        <template v-else>o Requisition Number</template>
        ou paciente que você deseja alterar
      </p>
      <div class="search-bar__search">
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout
            md-flex="100"
            md-flex-medium="100"
          >
            <md-input-container>
              <div
                id="btnSerachFilter"
                class="search-bar__search__icon-container"
              >
                <md-icon
                  md-src="/static/images/icon-search-small.svg"
                  class="search-bar__search__icon"
                />
              </div>
              <input
                id="inputSearchBar"
                v-model="searchQuery"
                class="search-bar__search__input md-input editos-input"
                type="text"
                placeholder="Buscar por OS ou Paciente"
                maxlength="255"
                @keyup.enter="search()"
              />
            </md-input-container>
          </md-layout>
          <md-layout md-flex="100">
            <md-button
              class="btn btn-nonenary"
              @click="closeMaintenanceModal()"
            >
              Cancelar
            </md-button>
            <md-button
              class="btn btn-primary edit-os__buttons"
              :disabled="validatorEmptyValue"
              @click="search()"
            >
              Pesquisar
            </md-button>
          </md-layout>
        </md-layout>
      </div>
    </md-dialog-content>
  </md-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OrderMaintenanceSearch',
  data() {
    return {
      searchQuery: '',
      validatorEmptyValue: true,
    }
  },
  computed: {
    ...mapGetters(['isOrderMaintenanceModalVisible', 'toggle']),
  },
  watch: {
    isOrderMaintenanceModalVisible() {
      if (this.isOrderMaintenanceModalVisible) {
        this.$refs.editOsModal.open()
        this.setComunicationSidebarShowOff(false)
        this.setPreferenceShowOff(false)
      } else {
        this.$refs.editOsModal.close()
      }
    },
    searchQuery: function (newValue) {
      if (!newValue) {
        this.validatorEmptyValue = true
      } else {
        this.validatorEmptyValue = false
      }
    },
  },
  beforeDestroy() {
    this.setOrderMaintenanceModalVisible(false)
  },
  methods: {
    ...mapActions([
      'setOrderMaintenanceModalVisible',
      'setComunicationSidebarShowOff',
      'setPreferenceShowOff',
      'setOrderShowOff',
    ]),
    search() {
      if (!this.validatorEmptyValue) {
        const isOnlyNumbers = /^\d+$/.test(this.searchQuery)
        let buildQuery

        if (isOnlyNumbers) {
          buildQuery = '/traceability/search?typeOfSearch=OA&q=' + this.searchQuery
        } else {
          buildQuery = '/traceability/search?typeOfSearch=PN&q=' + this.searchQuery
        }

        this.$router.push(buildQuery)
        this.setComunicationSidebarShowOff(false)
        this.setOrderShowOff(false)
      }
    },
    openMaintenanceModal() {
      this.setOrderMaintenanceModalVisible(true)
    },
    closeMaintenanceModal() {
      this.setOrderMaintenanceModalVisible(false)
    },
  },
}
</script>

<style lang="scss">
.edit-os-modal .md-dialog {
  min-width: 60%;
  height: auto;

  .md-layout {
    justify-content: center;
  }

  .edit-os {
    &__container {
      display: flex;
      justify-content: center;
      flex-direction: row;
      align-items: center;
    }

    &__buttons {
      margin-left: 10px;
    }
  }

  .editos-input {
    font-size: 16px !important;
    margin-left: 10px;
  }
}
</style>
